<template>
    <div
        v-if="isComponentReady"
        class="l-ss-c-search-popup-wrapper">
        <div
            :class="{
                'l-ss-c-search-popup-wrapper-mask-hidden':
                    isShowAgeCheckPopup ||
                    store.state.ui.isCategoriesListVisible ||
                    showResultsMask ||
                    isFiltersOpened
            }"
            :style="zIndexPopup"
            class="l-ss-c-search-popup-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="onClickOutside">
            <div
                :class="{
                    [`l-ss-c-search-popup-is-opened-mobile-nav`]: showMobileNavigation,
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    'l-ss-c-search-popup__shadow': $configuration.showInput,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <!--                <popup-->
                <!--                    v-if="$configuration.features.imageSearch"-->
                <!--                    :opened="store.state.ui.isImageSearchVisible"-->
                <!--                    scroll-to-top-on-mobile-->
                <!--                    :title="$t('imageSearch.title')"-->
                <!--                    class="l-ss-c-search-popup-image-search-popup"-->
                <!--                    @close="() => toggleImageSearch(false)">-->
                <!--                    <image-search-container-->
                <!--                        @search="startSearchByImage"-->
                <!--                        @image-search-button-select-file-click="value => $emit('image-search-button-select-file-click', value)"-->
                <!--                        @image-search-use-correct-link-click="value => $emit('image-search-use-correct-link-click', value)"-->
                <!--                        @image-search-use-incorrect-link-click="value => $emit('image-search-use-incorrect-link-click', value)"-->
                <!--                        @image-search-button-search-click="value => $emit('image-search-button-search-click', value)"/>-->
                <!--                </popup>-->

                <!--                <popup-->
                <!--                    v-if="$configuration.features.voiceSearch"-->
                <!--                    :opened="store.state.ui.isVoiceSearchActive"-->
                <!--                    scroll-to-top-on-mobile-->
                <!--                    class="l-ss-c-search-popup-voice-search-popup"-->
                <!--                    @close="() => toggleVoiceSearch(false)">-->
                <!--                    <voice-search-container :store="store"/>-->
                <!--                </popup>-->

                <div
                    class="l-ss-c-search-popup-content-wrapper"
                    :class="{
                        'l-ss-c-search-popup-content-wrapper-right-angles': isContentVisible,
                        'l-ss-c-search-popup-content-wrapper-with-result': isResultsVisible && totalItemsCount
                    }">
                    <div
                        v-if="$configuration.showInput"
                        class="l-ss-c-search-top-section-wrapper l-ss-c-search-popup-content-wrapper-child">
                        <div
                            :class="{ 'l-ss-c-search-popup-top-section-full-width': this.$configuration.completionsFullWidth }"
                            class="l-ss-c-search-popup-top-section">
                            <img
                                v-if="$configuration.logoSrc && !$screen.isMobile && logoAccess"
                                :src="$configuration.logoSrc"
                                @error="onLoadLogo()"
                                class="l-ss-c-search-popup-logo"
                                @click="() => $emit('search-popup-close')">
                            <search-input
                                ref="searchInput"
                                :data-border-radius="$screen.isMobile === true"
                                :enable-image-search="$configuration.features.imageSearch"
                                :enable-voice-search="$configuration.features.voiceSearch"
                                :is-cart-available="$configuration.features.addToCartButton"
                                :is-loading="isLoading"
                                :show-actions="true"
                                :image="base64Image"
                                :taps-completions="tapsCompletions"
                                v-bind="$props"
                                @blur="args => onSearchInputAction('search-input-blur', args)"
                                @search-input-change="$emit('search-input-change', $event)"
                                @change="args => onSearchInputAction('search-input-change', args)"
                                @focus="args => onSearchInputAction('search-input-focus', args)"
                                @tags-click="handleTagsClick"
                                @keyUpEnter="params => onSearchInputAction('search-input-enter', params)"
                                @toggle-image-picker="args => onSearchInputAction('toggle-image-picker', args)"
                                @toggle-voice-search="toggleVoiceSearch"
                                @autocomplete-search="onAutocompleteSearch"
                                @search-by-enter="$emit('search-by-enter')"
                                @handle-search="args => onSearchInputAction('handle-search', args)"
                                @click-reset-query-button="$emit('click-reset-query-button')"
                                @reset-query="args => onSearchInputAction('reset-query', args)"
                                @popup-close="args => onSearchInputAction('reset-query', args)"
                                @offer-click="value => $emit('offer-click', value)"
                                @category-click="value => $emit('category-click', value)"
                                @special-offers-click="value => $emit('special-offers-click', value)"
                                @suggestions-click="value => $emit('suggestions-click', value)"
                                @brand-click="value => $emit('brand-click', value)"
                                @history-click="value => $emit('brand-click', value)"
                                @popular-click="value => $emit('popular-click', value)"
                                @button-image-click="value => $emit('button-image-click', value)"
                                @search-click="value => $emit('search-click', value)"
                                @preview-tab-click="(value) => $emit('preview-tab-click', value)"
                                @delete-all-text="value => $emit('delete-all-text', value)"
                                @search-all="$emit('search-all')"
                                @preview-show-all-click="$emit('preview-show-all-click', $event)"
                                @show-all-click="handleShowAllClickEvent"
                                @params-click="$emit('params-click', $event)"
                                @params-search="onParamsSearch"
                                @add-to-cart-click="handleAddToCartClick"
                                @remove-from-cart-click="$emit('remove-from-cart-click', $event)"
                                @remove-history="(params) => $emit('remove-history', params)"
                                @close-completions="$emit('close-completions', $event)"
                                @click-close-button="$emit('click-close-button', $event)"
                                @completions-close="$emit('completions-close')"
                                @completions-open="(params) =>$emit('completions-open', params)"
                                @show-completions="isShowCompletions = $event">
                                <template #prefix>
                                    <i
                                        v-html="iconSearch"
                                        v-if="$screen.isMobile"></i>
                                </template>
                            </search-input>
                            <button
                                v-if="$screen.isMobile || (!$screen.isMobile && iconClosePopup)"
                                class="l-ss-c-button l-ss-c-search-popup-close-button"
                                v-html="!$screen.isMobile && iconClosePopup ? iconClosePopup : $t('cancel')"
                                @mousedown="onClickCloseButton">
                            </button>
                        </div>
                    </div>

                    <search-results-wrapper
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :store="store"
                        :search-state="searchState"
                        :query="query"
                        :total-items-count="totalItemsCount"
                        :is-results-visible="isResultsVisible"
                        :is-filters-block-visible="isFiltersBlockVisible"
                        :request-categories="requestCategories"
                        :results-category-id="resultsCategoryId"
                        :error-text-completions="errorTextCompletions"
                        :error-text-search="errorTextSearch"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :show-results-mask="showResultsMask"
                        :is-completions-loading="isCompletionsLoading"
                        :is-search-loading="isSearchLoading"
                        :loading-by-filters="loadingByFilters"
                        :limit="limit"
                        :search-response="searchResponse"
                        :search-request-id="searchRequestId"
                        :skip="skip"
                        :offer-templates="offerTemplates"
                        :filter-items="filterItems"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :currency-in-offers="currencyInOffers"
                        :filter-values="filterValues"
                        :from_completions="from_completions"
                        :all-categories-tree="allCategoriesTree"
                        :search="search"
                        :is-show-signature="isShowSignature"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        @autocomplete-search="val => $emit('autocomplete-search', val)"
                        @params-search="params => $emit('params-search', params)"
                        @navigate-category="handleNavigateCategory"
                        @page-reload="handlePageReload"
                        @search-image="$emit('search-image', $event)"
                        @tags-click="$emit('tags-click', $event)"
                        @handle-search="onSearchInputAction('handle-search')"
                        @search-input-change="params => $emit('search-input-change', params)"
                        @offer-click="$emit('offer-click', $event)"
                        @add-to-cart="args => onSearchInputAction('add-to-cart', args)"
                        @add-to-cart-click="$emit('add-to-cart-click', $event)"
                        @remove-from-cart-click="$emit('remove-from-cart-click', $event)"
                        @age-confirmed="$emit('age-confirmed')"
                        @results-category-click="$emit('results-category-click', $event)"
                        @filters-change="filters => $emit('filters-change', filters)"
                        @filter-click="params => $emit('filter-click', params)"
                        @click-on-show-offers="$emit('click-on-show-offers', $event)"
                        @toggle-filters="toggleFilters"
                        @sort-change="params => $emit('sort-change', params)"
                        @result-tab-click="$emit('result-tab-click', $event)"
                        @result-sort-click="params => $emit('result-sort-click', params)"
                        @reset-filters="$emit('reset-filters', $event)"
                        @reset-query="() => $emit('reset-query')"
                        @scroll-to-top="() => $emit('scroll-to-top')"
                        @navigate-page-next="() => $emit('navigate-page-next')"
                        @navigate-page-prev="() => $emit('navigate-page-prev')"
                        @toggle-image-picker="args => onSearchInputAction('toggle-image-picker', args)"
                        @button-image-click="event => $emit('button-image-click', { type: 'buttonImageClick', event })"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';
    import SearchInput from '../core/components/search-input/search-input.vue';
    import RootComponentMixin from '../core/mixins/root-component';
    import CompletionsMixin from '../core/mixins/completions';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    // import ImageSearchContainer from '../core/components/image-search-container';
    import iconClosePopup from '../core/assets/images/icons/close-popup.svg';
    import iconSearch from '../core/assets/images/icons/search-icon.svg';
    // import Popup from '../core/components/popup';
    // import { getCookie } from '/src/core/helpers/cookies';
    // import VoiceSearchContainer from '@/core/components/voice-search-container.vue';
    import SearchResultsWrapper from '@/core/components/search-results/search-results-wrapper.vue';

    const EVENT_CALLBACK_DELAY = 300;
    installPlugins();
    export default {
        components: {
            SearchResultsWrapper,
            // VoiceSearchContainer,
            SearchInput,
            // ImageSearchContainer,
            // Popup,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...CompletionsMixin.props,
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            from_completions: {
                type: String,
                default: '',
            },
            categoryId: {
                type: [String, Number],
                default: '',
            },
            query: {
                type: String,
                default: '',
            },
            params: {
                type: Array,
                default: () => ([]),
            },
            completions: {
                type: Array,
                required: false,
                default: () => ([]),
            },
            tapsCompletions: {
                type: Array,
                default: () => ([]),
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                localQueryParams: null,
                showMobileNavigation: false,
                showSearch: true,
                wrapperClickTarget: null,
                sectionImageKey: '',
                logoAccess: true,
                isShowCompletions: false,
            };
        },

        computed: {
            ...CompletionsMixin.computed,
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            zIndexPopup() {
                return { 'z-index': 1001 };
            },
            isFiltersOpened() {
                return this.store.state.ui.isFiltersOpened;
            },
            showResultsMask() {
                return this.$screen.isMobile && this.isShowCompletions;
            },
            isContentVisible() {
                return !!(this.store.state.ui.isCategoriesListVisible ||
                    (!this.isResultsVisible && this.isOpenSearchByImageOrVoice));
            },
            iconClosePopup() {
                const closePopupIcon = this.$configuration.closePopupIcon;

                if (closePopupIcon) {
                    return typeof closePopupIcon !== 'string' ?
                        iconClosePopup :
                        closePopupIcon;
                }

                return null;
            },
            iconSearch() {
                return iconSearch;
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            allCategoriesTree() {
                return this.requestCategories ? this.requestCategories.categoriesTree : [];
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            isOpenSearchByImageOrVoice() {
                return this.store.state.ui.isImageSearchVisible || this.store.state.ui.isVoiceSearchActive;
            },
            base64Image() {
                return this.store.state.base64Image;
            },
        },

        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                }
                this.localQueryParams = state ? { ...state } : {};
            },
        },

        beforeCreate() {
            Object.assign(this, { projectName: 'SearchBooster.io' });
            Object.assign(this, { href: 'https://searchbooster.io/' });
        },

        mounted() {
            this.$on('search-input-change', () => {
                this.resetImage();
            });
            this.$on('handle-search', () => {
                this.resetImage();
            });

            this.addCss(this.$configuration.searchResult.topBlock.customCss);
        },

        updated() {
            this.setValueToSignature();
        },

        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            onLoadLogo() {
                this.logoAccess = false;
            },
            addCss(cssCode) {
                let shDom = document.querySelector('searchbooster-search-popup');
                let style = document.createElement('style');
                if (style.styleSheet) {
                    style.styleSheet.cssText = cssCode;
                } else {
                    style.appendChild(document.createTextNode(cssCode));
                }
                shDom.shadowRoot.appendChild(style);
            },
            onClickOutside(event) {
                if (this.wrapperClickTarget === event.target) {
                    this.handleCloseWidgetCommonActions();
                    this.closeWidgetClick('lossFocus', event);
                }
            },
            onClickCloseButton(event) {
                this.$emit('click-close-button', { currentQuery: this.query, isShowCompletions: this.isShowCompletions });
                this.handleCloseWidgetCommonActions();
                this.closeWidgetClick('buttonClick', event);
            },
            handleCloseWidgetCommonActions() {
                this.$emit('reset-query');
                this.resetImage();
                this.$emit('search-popup-close');
            },
            closeWidgetClick(clickType, event) {
                this.$emit('close-widget-click', {
                    type: 'closeWidget',
                    query: this.query,
                    customEventType: clickType,
                    event,
                });
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            // onToggleCategories(value) {
            //     const resultValue = value === undefined ? !this.store.state.ui.isCategoriesListVisible : !!value;
            //     if (resultValue) {
            //         this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
            //         this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
            //         this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            //     }
            //     this.store.state.ui.isCategoriesListVisible = resultValue;
            //     if (resultValue) {
            //         this.$emit('search-popup-fetch-categories');
            //     }
            // },
            // startSearchByImage(baseImage) {
            //     this.store.commit('base64Image/SET_PROPERTY', baseImage);
            //     this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
            //     this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
            //     this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
            // },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            },
            toggleVoiceSearch(value) {
                const isVoiceSearch = value === undefined ? !this.store.state.ui.isVoiceSearchActive : !!value;

                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isVoiceSearchActive',
                    value: isVoiceSearch,
                });

                this.$emit('voice-search', isVoiceSearch);
            },
            resetImage() {
                this.store.commit('base64Image/SET_PROPERTY', null);
            },
            onSearchInputAction(eventName, params) {
                let afterEventCallback = null;
                switch (eventName) {
                    case 'search-input-change':
                        this.$emit(eventName, params);
                        break;
                    case 'handle-search':
                        this.toggleFilters(false);
                        this.$emit(eventName);
                        break;
                    case 'toggle-image-picker':
                        this.toggleImageSearch(params);
                        break;
                    case 'popup-close':
                        this.$emit('search-popup-close');
                        break;
                    case 'search-input-blur':
                        this.$emit('search-input-blur');
                        break;
                    case 'search-input-focus':
                        this.$emit('search-input-focus');
                        break;
                    case 'search-input-enter':
                        this.$emit(eventName, params);
                        break;
                    case 'reset-query':
                        this.resetImage();
                        this.$emit(eventName, params);
                        break;
                    case 'remove-history':
                        this.$emit('remove-history');
                        break;
                    default:
                        afterEventCallback = () => {
                            this.showSearch = true;
                        };
                        this.$emit(eventName, params);
                }
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                if (afterEventCallback) {
                    setTimeout(afterEventCallback, EVENT_CALLBACK_DELAY);
                }
            },
            setValueToSignature() {
                if (!this.isShowSignature)
                    return;
                const i18nStr = this.$t('signature', [this.projectName]);
                const preparedValue = i18nStr.replace(this.projectName, '');
                const refsList = i18nStr.indexOf(this.projectName) === 0
                    ? [this.$refs.signatureLeft, this.$refs.signatureRight]
                    : [this.$refs.signatureRight, this.$refs.signatureLeft];
                if (!refsList.some(Boolean))
                    return;
                refsList[0].innerText = this.projectName;
                refsList[0].href = this.href;
                refsList[0].target = '_blank';
                refsList[1].innerText = preparedValue;
            },
            // onDenyAgeCheck() {
            //     if (this.$configuration.features.ageCheckPopupType === 'filter') {
            //         this.$emit('search-all');
            //     } else {
            //         this.$emit('reset-query');
            //         this.$emit('search-popup-close');
            //         window.location.href = getCookie('ageCheckPopupRedirectUrl', this.$configuration.ageCheckPopupRedirectUrl);
            //     }
            // },
            onParamsSearch(params) {
                this.$emit('params-search', params);
            },

            // onResetCategory() {
            //     this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
            //     this.emitNavigateCategory({ skip: 0, categoryId: '' });
            // },

            onAutocompleteSearch(value) {
                this.$emit('autocomplete-search', value);
            },

            handleTagsClick(data) {
                data.hasResults = this.isResultsVisible;
                this.$emit('tags-click', data);
            },
        },
    };
</script>
